import React from 'react';
import {
  Box,
  Container,
  Typography,
  useTheme,
} from '@mui/material';
import AnimatedElement from './AnimatedElement';

const MembershipSection = () => {
  const theme = useTheme();

  return (
    <Box
      id="membership"
      sx={{
        bgcolor: 'primary.white'
      }}
    >
      {/* Ganzflächiges Bild ohne Padding */}
      <Container
        maxWidth={false}
        sx={{
          maxWidth: '1400px',
          mx: 'auto',
          px: 0
        }}
      >
        <AnimatedElement>
        <Box
          component="img"
          src="/bild_1.webp" // Platzhalter-Bild
          alt="Vorteile des Corps Guestphalia"
          sx={{
            width: '100%',
            height: { xs: '400px', md: 'auto' },
            objectFit: 'cover',
            display: 'block',
            margin: { xs: '40px 0', md: '100px 0' }
          }}
        />
        </AnimatedElement>
      </Container>

      {/* Content-Bereich mit Padding-Left */}
      <AnimatedElement>
      <Box sx={{ py: { xs: 4, md: 12 } }}>
        <Container
          maxWidth={false}
          sx={{
            maxWidth: '1400px',
            mx: 'auto',
            pl: { xs: 2, md: 10 }, // 80px padding-left auf Desktop
            pr: 2
          }}
        >
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: '5fr 5fr 2fr' },
              gap: 4,
              alignItems: 'start'
            }}
          >
            {/* Spalte 1: Sektionsüberschrift */}
            <Box>
              <Typography
                variant="h2"
                component="h2"
                sx={{
                  fontSize: { xs: '1.6rem', sm: '1.8rem', md: '2.1rem' },
                fontWeight: 500,
                color: '#000',
                lineHeight: 1.2,
                textAlign: 'left'
                }}
              >
                VORTEILE VON GUESTPHALIA
              </Typography>
              <Box 
                          sx={{
                            height: '4px', 
                            width: '100px', 
                            backgroundColor: 'rgb(58, 123, 62)', 
                            marginTop: { xs: '20px', sm: '30px', md: '40px' },
                            marginBottom: '20px'
                          }}
                        />

              <Box sx={{ paddingLeft: { xs: '0px', md: '70px', lg: '100px' }, paddingTop: { xs: '0px', sm: '40px', md: '100px' } }}>
                <Box
                  component="img"
                  src="/vorteile_bild_2.webp" // Platzhalter-Bild
                  alt="Vorteile des Corps Guestphalia"
                  sx={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'cover',
                    display: 'block',
                    margin: '20px 0',
                  }}
                />
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { xs: '1rem', md: '1.1rem' },
                    lineHeight: 1.6,
                    color: '#000',
                    textAlign: 'justify'
                  }}
                >
                  In einer Studentenverbindung Anschluss zu finden, kann eine spannende Erfahrung sein. Das Wichtigste ist, du selbst zu sein, offen und respektvoll zu sein und aktiv an den Aktivitäten der Verbindung teilzunehmen. Mit der Zeit wirst du Anschluss finden und eine positive Erfahrung in deiner Studentenverbindung machen. Das Wohnen in der Nähe der Freien Universität (FU) Berlin, einer der renommiertesten Universitäten in Deutschland, bietet zudem viele Vorteile für Studenten.
                </Typography>
              </Box>

              <Box sx={{ marginTop: { xs: '40px', md: '60px', lg: '80px' } }}></Box>

              <Box sx={{ paddingLeft: { xs: '0px', md: '70px', lg: '100px' }, paddingTop: { xs: '0px', sm: '40px', md: '100px' } }}>
                <Box
                  component="img"
                  src="/vorteile_bild_4.webp" // Platzhalter-Bild
                  alt="Vorteile des Corps Guestphalia"
                  sx={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'cover',
                    display: 'block',
                    margin: '20px 0',
                  }}
                />
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { xs: '1rem', md: '1.1rem' },
                    lineHeight: 1.6,
                    color: '#000',
                    textAlign: 'justify'
                  }}
                >
                  Freunde können einen wertvollen Beitrag dazu leisten, dass der Einstieg ins Berufsleben einfacher wird. Durch Netzwerken, gemeinsame Karriereinteressen, Ratschläge und Erfahrungsaustausch können Freunde dazu beitragen, dass man besser in das Berufsleben startet und die Herausforderungen besser bewältigt. Es ist wichtig, das Potenzial von Freundschaften für die berufliche Entwicklung zu erkennen und diese Beziehungen zu pflegen
                </Typography>
              </Box>




            </Box>

            {/* Spalte 2: Zweispaltiger Fließtext */}
            <Box>
              
              <Box sx={{ paddingLeft: { xs: '0px', md: '70px', lg: '100px' } }}>
                <Box
                  component="img"
                  src="/vorteile_bild_1.webp" // Platzhalter-Bild
                  alt="Vorteile des Corps Guestphalia"
                  sx={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'cover',
                    display: 'block',
                    margin: '20px 0',
                  }}
                />
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { xs: '1rem', md: '1.1rem' },
                    lineHeight: 1.6,
                    color: '#000',
                    textAlign: 'justify'
                  }}
                >
                 Das Wohnen in der Nähe der Freien Universität (FU) Berlin, einer der renommiertesten Universitäten in Deutschland, bietet viele Vorteile für Studierende, darunter fällt Zeitersparnis, einfachen Zugang zu Ressourcen, aktives studentisches Leben, Vernetzungsmöglichkeiten, Flexibilität und Unabhängigkeit sowie das Erleben des Stadtlebens und der Kultur in Berlin.
                </Typography>
              </Box>

              <Box sx={{ marginTop: { xs: '40px', md: '60px', lg: '80px' } }}></Box>

               <Box sx={{ paddingLeft: { xs: '0px', md: '70px', lg: '100px' } }}>
                <Box
                  component="img"
                  src="/vorteile_bild_3.webp" // Platzhalter-Bild
                  alt="Vorteile des Corps Guestphalia"
                  sx={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'cover',
                    display: 'block',
                    margin: '20px 0',
                  }}
                />
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { xs: '1rem', md: '1.1rem' },
                    lineHeight: 1.6,
                    color: '#000',
                    textAlign: 'justify'
                  }}
                >
                 Erfahrene Studierende, die ihre Studienzeit bereits absolviert haben, können wertvolle Hilfe und Unterstützung für neue Studenten bieten. Sie können praktische Tipps und Ratschläge geben, ihre eigenen Erfahrungen teilen, als Mentoren dienen, bei der sozialen Integration unterstützen und den akademischen Erfolg fördern. Die Unterstützung von erfahrenen Studierenden kann dazu beitragen, dass neue Studierende erfolgreich in ihr Studium starten und sich schneller in die studentische Gemeinschaft integrieren
                </Typography>
              </Box>

            </Box>

            {/* Spalte 3: Gedrehter Text "VORTEILE" */}
            <Box
              sx={{
                 display: { xs: 'none', md: 'flex' },
              justifyContent: 'center',
              alignItems: 'flex-start',
              height: '100%',
              minHeight: { xs: '100px', md: '400px' }
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                <div style={{ height: '100px', width: '2px', backgroundColor: '#3a7b3e', marginLeft: '-4px' }}></div>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { xs: '0.8rem', md: '0.9rem' },
                    fontWeight: 500,
                    color: '#000',
                    writingMode: { xs: 'horizontal-tb', md: 'vertical-rl' },
                    textOrientation: { md: 'mixed' },
                    whiteSpace: 'nowrap',
                    letterSpacing: '0.2em',
                    textAlign: 'center',
                  }}
                >
                  VORTEILE
                </Typography>
              </div>

            </Box>
          </Box>
        </Container>
      </Box>
      </AnimatedElement>
    </Box>
  );
};

export default MembershipSection;